module.exports = __webpack_public_path__ + "img/symbol_7.082d0c7e.png";